import React from "react";
import { Box, useTheme, useMediaQuery } from "@material-ui/core";
import { getBackgroundImage, getBoxMarginProps, getBoxPaddingProps, getBreakpointValue, getColor, getSize } from './functions';
import Countdown from "react-countdown";
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
    countdown: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-evenly',
    },
    number: {
        minWidth: '50px',
        textAlign: 'center'
    },
    separator: {
        padding: '0 8px'
    },
    label: {
        fontWeight: '700',
        textTransform: 'uppercase',
    }
}));

const defaultProps = {
    xs: {
        background: {},
        border: {},
        color: '',
        fontSize: '',
        marginLeft: '',
        marginTop: '',
        marginRight: '',
        marginBottom: '',
        textAlign: ''
    },
    md: {
        background: {
            size: 'cover'
        },
        border: {},
        color: '',
        fontSize: '',
        marginLeft: '',
        marginTop: '',
        marginRight: '',
        marginBottom: '',
        textAlign: ''
    },
    background: {
        size: 'cover'
    },
    border: {},
    color: '',
    fontSize: '',
    marginLeft: '',
    marginTop: '',
    marginRight: '',
    marginBottom: '',
    textAlign: ''
};

export const CountDown = (props) => {
    props = {
        ...defaultProps,
        ...props
    };
    const classes = useStyles();
    const theme = useTheme();
    const breakpoint = useMediaQuery(theme.breakpoints.only('xs')) ? 'xs' : 'md';
    const {
        dateEnd
    } = props;
    const countDownProps = {
        style: {
            backgroundImage: getBackgroundImage(props, breakpoint),
            backgroundSize: getBreakpointValue(props, breakpoint, 'background', 'size'),
            backgroundColor: getColor(getBreakpointValue(props, breakpoint, 'background', 'color')),
            backgroundRepeat: getBreakpointValue(props, breakpoint, 'background', 'repeat'),
            backgroundPosition: getBreakpointValue(props, breakpoint, 'background', 'position'),
        }
    }
    const countDownNumberProps = {
        style: {
            fontSize: '30px',
            fontWeight: '700',
            minWidth: '50px',
            textAlign: 'center'
        }
    }
    const countDownLabelProps = {
        style: {
            fontSize: '10px',
            fontWeight: '700',
            textTransform: 'uppercase',
        }
    }
    const countDownSeparatorProps = {
        style: {
            padding: '0 8px'
        }
    }
    const borderRadius = {
        borderTopLeftRadius: Number(getBreakpointValue(props, breakpoint, 'border', 'borderTopLeftRadius')) || null,
        borderTopRightRadius: Number(getBreakpointValue(props, breakpoint, 'border', 'borderTopRightRadius')) || null,
        borderBottomLeftRadius: Number(getBreakpointValue(props, breakpoint, 'border', 'borderBottomLeftRadius')) || null,
        borderBottomRightRadius: Number(getBreakpointValue(props, breakpoint, 'border', 'borderBottomRightRadius')) || null
    };
    const color = getColor(props.color);
    const size = getSize(props.size);
    const sizeLabel = getSize(props.sizeLabel);

    if (color) countDownProps.style.color = color;
    if (size) {
        countDownNumberProps.style.fontSize = size;
        countDownSeparatorProps.style.fontSize = size;
    }
    if (sizeLabel) countDownLabelProps.style.fontSize = sizeLabel;

    Object.entries(borderRadius).map(borderSide => {
        if (borderSide[1]) {
            countDownProps.style[borderSide[0]] = borderSide[1];
        }
    });

    if (getBreakpointValue(props, breakpoint, 'border', 'borderColor')) {
        countDownProps.style.borderTopWidth = Number(getBreakpointValue(props, breakpoint, 'border', 'borderTopWidth')) || 0;
        countDownProps.style.borderBottomWidth = Number(getBreakpointValue(props, breakpoint, 'border', 'borderBottomWidth')) || 0;
        countDownProps.style.borderRightWidth = Number(getBreakpointValue(props, breakpoint, 'border', 'borderRightWidth')) || 0;
        countDownProps.style.borderLeftWidth = Number(getBreakpointValue(props, breakpoint, 'border', 'borderLeftWidth')) || 0;
        countDownProps.style.borderColor = getColor(getBreakpointValue(props, breakpoint, 'border', 'borderColor'));
        countDownProps.style.borderStyle = 'solid';
    }

    if (getBreakpointValue(props, breakpoint, 'hidden', null, false)) countDownProps.style.opacity = '0.3';

    const now = new Date(dateEnd + " 23:59:59");

    return (
        <Box
            {...getBoxMarginProps(props, breakpoint)}
            {...getBoxPaddingProps(props, breakpoint)}
            textAlign={getBreakpointValue(props, breakpoint, 'textAlign')}
            {...countDownProps}
        >
            <Countdown date={now.getTime()}
                renderer={({ days, hours, minutes, seconds, completed }) => {
                    const zeroPad = (num, places) => String(num).padStart(places, '0')

                    if (completed) {
                        return <></>;
                    } else {
                        return (
                            <div className={classes.countdown}>
                                <span {...countDownNumberProps}>
                                    {zeroPad(hours + (days * 24), 2)}
                                    <div {...countDownLabelProps}>horas</div>
                                </span>
                                <span {...countDownSeparatorProps}>:</span>
                                <span {...countDownNumberProps}>
                                    {zeroPad(minutes, 2)}
                                    <div {...countDownLabelProps}>minutos</div>
                                </span>
                                <span {...countDownSeparatorProps}>:</span>
                                <span {...countDownNumberProps}>
                                    {zeroPad(seconds, 2)}
                                    <div {...countDownLabelProps}>segundos</div>
                                </span>
                            </div>
                        )
                    }
                }}
            />
        </Box>
    );
};